export default {
  title: 'Články',
  subtitle: 'Novinky, návody a aktuality z terminálu PixelKey.',
  loadFailed: 'Články se nepodařilo načíst. Zkuste to prosím znovu.',
  emptyTitle: 'Žádné články',
  emptyBody: 'Tomuto filtru zatím neodpovídají žádné články. Zkuste jinou kategorii.',
  more: 'Další články',
  published: 'Publikováno',
  featured: 'Doporučené',
  readArticle: 'Přečíst článek',
  latest: 'Nejnovější články',
  readingMinutes: '{n} min čtení',
  read: 'Číst',
  backToArticles: 'Zpět na články',
  notFound: 'Článek nenalezen',
  shareThis: 'Sdílet tento článek',
  copyLink: 'Kopírovat odkaz',
  linkCopied: 'Odkaz zkopírován',
};
